var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCheckout = function SvgIcCheckout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.369 6.595a21.9 21.9 0 0 0-.03.879c-.006.352-.006.74-.006 1.172v.57h.584a204.038 204.038 0 0 1 .005-1.734c.001-.104.003-.204.006-.301h8.144a83.716 83.716 0 0 1 .011 1.465v.57h.583v-.57c0-.431 0-.82-.005-1.172a21.821 21.821 0 0 0-.03-.879c-.06-.926-.22-1.52-.648-1.95-.365-.367-.85-.538-1.556-.617v-.382a.312.312 0 1 0-.623 0v.335C9.302 3.958 8.708 3.958 8 3.958s-1.302 0-1.805.023v-.335a.312.312 0 1 0-.622 0v.382c-.707.08-1.191.25-1.556.617-.428.43-.588 1.024-.648 1.95Zm.572 3.88h-.584c.049 1.055.199 1.709.66 2.172.683.686 1.783.686 3.983.686s3.3 0 3.983-.686c.472-.474.618-.883.663-1.98h-.584c-.011.276-.03.256-.059.473-.077.573-.217.876-.432 1.093-.216.216-.518.357-1.088.434-.588.08-1.367.08-2.483.08-1.117 0-1.895 0-2.483-.08-.57-.077-.873-.218-1.088-.434-.215-.217-.355-.52-.432-1.094a7.916 7.916 0 0 1-.056-.664Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.917 9.216h-.583c.001.474.006.891.023 1.26h.584a28.82 28.82 0 0 1-.024-1.26Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.004h4.685M13.514 8.533 14.8 10l-1.286 1.475",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcCheckout;